import React from "react";
import Skeleton from "react-loading-skeleton";
import { ServerCard } from "./";

export default function ServerOverviewGrid({
  isLoading,
  displayServers,
  statusConfig,
  handleViewLogs,
  translations,
}) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
            <div className="flex justify-between items-start mb-4">
              <div className="flex gap-3">
                <Skeleton circle width={40} height={40} />
                <div>
                  <Skeleton width={120} height={18} />
                  <Skeleton width={80} height={12} className="mt-1" />
                </div>
              </div>
              <Skeleton width={60} height={24} className="rounded-full" />
            </div>
            <div className="space-y-3">
              <Skeleton height={8} className="rounded-full" />
              <div className="grid grid-cols-3 gap-2">
                <Skeleton height={40} className="rounded-lg" />
                <Skeleton height={40} className="rounded-lg" />
                <Skeleton height={40} className="rounded-lg" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
      {displayServers.map((server) => (
        <ServerCard
          key={server.id}
          server={server}
          statusConfig={statusConfig}
          onViewLogs={handleViewLogs}
          translateServerName={(name) => translations.serverNames[name] || name}
          translateRegion={(region) => translations.regions[region] || region}
        />
      ))}
    </div>
  );
}
